<template>
	<div :class="[{ 'is-survey': isSurvey }, {'is-not-survey': !isSurvey}]">
		<div class="query-response">
			<div class="response" v-for="(r, i) in response" :key="i">
				<!-- <FlagRecord
					v-if="questionnaire[i] && questionnaire[i].problem && isSurvey && getUserType != 'observer'"
					:question="question"
					:event="questionnaire[i]"
					:patient="patient">
				</FlagRecord> -->
				<div :class="['date', {'no-answer-date': !r || !r[0]}]" v-if="response.length > 1">
					{{ formatDate(questionnaire[i].completed) }}
				</div>
				<div class="answer-wrapper">
					<QueryPartial
						:response="r" 
						:question="question">
					</QueryPartial>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import QuestionResponse from '.'
import { mapActions, mapGetters } from 'vuex'
import QueryPartial from './partialResponse/QueryPartial'
export default {
	name: 'query',
	extends: QuestionResponse,
	data() {
		return {
		}
	},
	computed: {
		...mapGetters(['getUserType']),
		...mapGetters('user', ['getUser']),
		...mapGetters('auth', ['getUserId']),
		...mapGetters('provider', [ 'allPatientsChosen', 'getProviderNameById']),
	},
	components: {
		QueryPartial
	},
	methods: {
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";

.query-response {
	min-height: 30px;
	.response {
		.date {
			margin-top: 10px;
		}

		.no-answer-date {
			margin-top: 0px;
		}
	}
}
</style>